import {getToken} from "@/api/user";

declare const window : Window;
let currentUrl = new URL(window.location.toString());


export const apiRoot = (process.env.NODE_ENV !== 'production')  ? `${currentUrl.protocol}//${currentUrl.hostname}:3001/api` : `${currentUrl.protocol}//${currentUrl.hostname}/api`;

console.log('Detected apiRoot', apiRoot);

export function api(path: string) {
    return `${apiRoot}${path}`;
}


export async function apiFetch(path:string, method:string, data = {}) {
    const request = new Request(api(path), {
        method,
        mode: 'cors',
        redirect: 'follow',
        headers: new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': getToken() || ''
        }),
        body: JSON.stringify(data)
    });
    return await fetch(request);
}